// Set heading height in serviceCareer block
const body = document.querySelector('body');

window.addEventListener("load", () => {
    if (body.offsetWidth > 1200) {
        calcTitleHeight(3);
        addMbForSingleButton(3);
    } else if (body.offsetWidth <= 1200 && body.offsetWidth >= 768) {
        calcTitleHeight(2);
        addMbForSingleButton(2);
    } else if (body.offsetWidth < 768) {
        calcTitleHeight(1);
        addMbForSingleButton(1);
    }
}, true);

const calcTitleHeight = (colNumber) => {
    const serviceCareerSection = document.querySelectorAll('.service-career');

    serviceCareerSection.forEach(section => {
        const tiles = section.querySelectorAll('.service-career__heading-wrapper, .card-header');
        let threeElemArrays = createThreeElemArrays(colNumber, tiles);

        threeElemArrays.forEach(row => {
            const heights = row.map(tile => tile.offsetHeight);
            const maxHeights = Math.max(...heights);
            row.map(item => item.style.minHeight = `${maxHeights}px`);
        });
    });
}

const addMbForSingleButton = (colNumber) => {
    const serviceCareerSection = document.querySelectorAll('.service-career');
    serviceCareerSection.forEach(section => {
        const tiles = section.querySelectorAll('.card-footer');
        let threeElemArrays = createThreeElemArrays(colNumber, tiles);

        threeElemArrays.forEach(row => {
            const hasExtraLink = row.map(tile => !!tile.querySelector('.btn-link'));
            row.forEach((item, index) => {
                if (hasExtraLink.includes(true) && !hasExtraLink[index]) {
                    item.querySelector('.btn-light, .btn-primary')?.classList.add('mb-5');
                }
            } );
        });
    });
}

const createThreeElemArrays = (colNumber, tiles) => {
    let threeElemArrays = [];
    for (let idx = 0; idx < [...tiles].length; idx += colNumber) {
        threeElemArrays.push([...tiles].slice(idx, idx + colNumber));
    }

    return threeElemArrays;
}